import { useState, useEffect, type PropsWithChildren } from 'react';

/** Delayed Props */
type DelayedProps = {
  /**
   * The time to wait before showing the component.
   * @default = `3000` (3 seconds)
   */
  delay?: number;
};

const Delayed = ({ children, delay = 3000 }: PropsWithChildren<DelayedProps>) => {
  const [willShow, setWillShow] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setWillShow(true);
    }, delay);

    return () => clearTimeout(timerId);
  }, [delay]);

  return willShow ? children : null;
};

export { Delayed };
export default Delayed;
